<template>
  <v-container fluid class="px-0">
    <v-form @submit="updatePolicy()" v-model="valid" ref="form" class="">
      <!-- <v-layout justify-end class="mt-sm-n10" wrap>
        <h4 class="dark--text font-weight-light">Require User to Agree</h4>
        <v-switch class="mt-n1 ms-2"></v-switch>
      </v-layout> -->
      <v-layout wrap>
        <v-flex xs12 sm8 md7>
          <div class="mb-2">Terms (English)</div>
          <vue-editor v-model="text_en" :disabled="!isEditEn" class="tw-min-h-[200px] tw-bg-white" />
          <div v-if="enError" class="mt-1 red--text text-caption">English Terms are required</div>
        </v-flex>
        <v-flex class="ms-sm-16 ms-md-14 ms-lg-10 mt-n16 mt-sm-0">
          <v-btn color="light" :width="$vuetify.breakpoint.smAndUp ? 150 : 100" @click="editEn" class="mt-14 dark--text text-capitalize font-weight-bold">
            Edit
          </v-btn>
          <v-spacer></v-spacer>
        </v-flex>
      </v-layout>
      <v-layout class="mt-8 " wrap>
        <v-flex xs12 sm8 md7>
          <div class="mb-2 ">Terms (Arabic)</div>
          <vue-editor v-model="text_ar" :disabled="!isEditAr" class="tw-min-h-[200px] tw-bg-white" />
          <div v-if="arError" class="mt-1 red--text text-caption">Arabic Terms are required</div>
        </v-flex>
        <v-flex class="ms-sm-16 ms-md-14 ms-lg-10 mt-n16 mt-sm-0">
          <v-btn color="light" :width="$vuetify.breakpoint.smAndUp ? 150 : 100" @click="editAr" class="mt-14 dark--text font-weight-bold text-capitalize">
            Edit
          </v-btn>
          <v-spacer></v-spacer>
        </v-flex>
      </v-layout>
      <v-flex>
        <v-row>
          <v-flex xs12 sm12 md10 lg9 class="mt-6 pe-2">
            <v-row justify="end">
              <v-btn color="primary" width="150" @click="updatePolicy" :loading="btnloading" class="mt-4 light--text font-weight-bold text-capitalize">
                Save
              </v-btn>
            </v-row>
          </v-flex>
        </v-row>
      </v-flex>
    </v-form>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">{{ text }}</v-snackbar>
  </v-container>
</template>
<script>
import { requiredValidator } from "../../core/methods/validations";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor,
  },

  data() {
    return {
      requiredValidator: requiredValidator,
      btnloading: false,
      enError: false,
      arError: false,
      dialog: false,
      showDialog: false,
      text_en: "",
      snackbar: false,
      text: "",
      valid: true,
      isEditEn: false,
      isEditAr: false,
      policyId: "",
    };
  },
  apollo: {
    getPolicy() {
      return {
        query: require("../api/getPolicy.graphql"),
        result({ data, loading }) {
          this.text_en = data.getPolicy.text_en;
          this.text_ar = data.getPolicy.text_ar;
          this.policyId = data.getPolicy._id;
          this.loading = loading;
        },
      };
    },
  },
  methods: {
    editEn() {
      this.isEditEn = true;
    },
    editAr() {
      this.isEditAr = true;
    },
    updatePolicy() {
      this.enError = false;
      this.arError = false;
      if (!this.text_en || this.text_en.replace(/<(.|\n)*?>/g, "").trim() === "") {
        this.enError = true;
      }
      if (!this.text_ar || this.text_ar.replace(/<(.|\n)*?>/g, "").trim() === "") {
        this.arError = true;
      }
      if (this.enError || this.arError) {
        this.alertErrorMsg = "Please fill all required fields.";
        this.alertError = true;
        return;
      }
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("../api/updatePolicy.graphql"),
          variables: {
            id: this.policyId,
            text_en: this.text_en,
            text_ar: this.text_ar,
          },
        })
        .then(() => {
          this.text = "Policy updated";
          this.isEditEn = false;
          this.isEditAr = false;
          this.snackbar = true;
          this.btnloading = false;
          this.dialog = false;
        })
        .catch(error => {
          this.btnloading = false;
          console.log(error);
        });
    },

    close() {
      this.dialog = false;
    },
  },
};
</script>
